import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_PROGRAM_MEMBERSHIPS_STATS, GET_PROGRAM_MEMBERSHIPS_STATS_ERROR, GET_PROGRAM_MEMBERSHIPS_STATS_SUCCESS } from '../../actions.js';

function* getProgramMembershipsStats({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/v1/membership-stats`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_PROGRAM_MEMBERSHIPS_STATS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PROGRAM_MEMBERSHIPS_STATS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PROGRAM_MEMBERSHIPS_STATS_ERROR, payload: error });
  }
}

export function* watchGetProgramMembershipsStats() {
  yield takeEvery(GET_PROGRAM_MEMBERSHIPS_STATS, getProgramMembershipsStats);
}

function* getProgramMembershipsStatsSaga() {
  yield all([fork(watchGetProgramMembershipsStats)]);
}

export default getProgramMembershipsStatsSaga;
